import { useDispatch } from "react-redux";
import { useCallback } from "react";

import useShallowSelector from "./useShalowSelector";
import { selectUISettings } from "./../store/ui/selectors";
import { changeSettings } from "./../store/ui/actionCreators";
import { SettingsSections } from "./../store/ui/types";

export interface onOpen {
    (): void;
}
export interface onClose {
    (): void;
}

export interface changeCurrentSection {
    (newCurrent: SettingsSections): void;
}

type UseSettings = () => {
    onOpen: onOpen;
    onClose: onClose;
    isOpen: boolean;
    currentSection: SettingsSections;
    changeCurrentSection: changeCurrentSection;
};

const useSettings: UseSettings = () => {
    const { isOpen, currentSection } = useShallowSelector(selectUISettings);
    const dispatch = useDispatch();

    const onOpen: onOpen = useCallback(() => {
        if (!isOpen) dispatch(changeSettings({ isOpen: true }));
    }, [dispatch, isOpen]);

    const onClose: onClose = useCallback(() => {
        if (isOpen) dispatch(changeSettings({ isOpen: false }));
    }, [dispatch, isOpen]);

    const changeCurrentSection: changeCurrentSection = useCallback(
        newCurrent => {
            if (currentSection !== newCurrent) dispatch(changeSettings({ currentSection: newCurrent }));
        },
        [dispatch, currentSection],
    );

    return { onOpen, onClose, isOpen, currentSection, changeCurrentSection };
};

export default useSettings;
